import PlanningStatusEnum from '../Enums/PlanningStatusEnum';
import userHelper from '../Helpers/userHelper';

export default class PlanningDetailStatusUpdateItem {
  Ids: number[];
  IsSingle: boolean;
  IsAdmin: boolean;
  To: string;
  CancellationDecision: string;
  CancellationComment: string;
  // Single-item context (only set when exactly one item is selected).
  PlanningDetailId: number;
  FieldworkOrderNumber: number;
  StartDate: Date;
  EndDate: Date;
  CurrentStatus: string;
  NumberOfPlannedAssignments: number;
  CurrentCancellationDecision: string;
  CurrentCancellationComment: string;

  constructor(selectedItems) {
    const items = selectedItems ?? [];
    this.Ids = items.map((item) => item.PlanningDetailId);
    this.IsSingle = items.length === 1;
    this.IsAdmin = userHelper.isAdmin();
    this.CancellationDecision = '';
    this.CancellationComment = '';

    if (this.IsSingle) {
      const single = items[0];
      this.PlanningDetailId = single.PlanningDetailId;
      this.FieldworkOrderNumber = single.FieldworkOrderNumber;
      this.StartDate = single.StartDate;
      this.EndDate = single.EndDate;
      this.CurrentStatus = single.Status;
      this.NumberOfPlannedAssignments = single.NumberOfPlannedAssignments;
      this.CurrentCancellationDecision = single.CancellationDecision;
      this.CurrentCancellationComment = single.CancellationComment;
      this.To = '';
    } else {
      this.To = PlanningStatusEnum.ClientConfirmed;
    }
  }
}
